import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Region Feedback',
	url: '/regions/feedback',
	icon: 'map',
}];

export default class RegionFeedback extends Framework.Components.View {

	render() {
		let {history,roles} = this.props;
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					{/*<Button data-id="add-region" onClick={this.toggle('modalSubRegion')} size="sm" color="primary">*/}
					{/*	<i className="fa fa-users"/>&nbsp;&nbsp;Add Sub Region*/}
					{/*</Button>*/}
				</Framework.Components.PageBar>

				<Objects.RegionFeedback
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showButtons={this.props.roles.includes(10)}
				/>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Region"}
					object={Objects.SubRegion}
					history={this.props.history}
					toggle={this.state.modalSubRegion}
					reportClose={this.reportClose('modalSubRegion')}
					afterSave={() => this.setState({refresh: !this.state.refresh})}
					size={'lg'}

				/>

			</div>
		);
	}
}

